import { createStore } from 'vuex';
import themeLayout from './modules/themeLayout/actionCreator';
import chartContent from './modules/chartContent/actionCreator';
import firebase from './modules/authentication/firebase/actionCreator';
import auth from './modules/authentication/axios/actionCreator';
import content from './modules/content/content';
import createPersistedState from 'vuex-persistedstate'

export default createStore({
  modules: {
    themeLayout,
    chartContent,
    content,
    auth,
    firebase,
  },
  plugins: [
    createPersistedState({
      paths: ['auth.site_list','auth.tabsList','auth.updatedTabs','content.tagsId','content.tagsObejct']
    })
  ]
});
